

<template>
  <div>
    <!-- formulario de asistencia -->

    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="modalAsistencia" maxWidth="1000" @close-modal="$emit('close')">
        <template v-slot:title>
          Crear asistencia de clase <v-chip dark class="ml-2" :color="datosProgDocente.color_nivel">
            Nivel: {{ datosProgDocente.desc_nivel }}
            {{ datosProgDocente.desc_grado }}
          </v-chip>
        </template>
        <template v-slot:body>
          <v-row>
            <v-col cols="12" class="d-flex justify-center">
              <p class="body-1 mb-0 black--text">
                <span class="font-weight-black">Unidad: </span>
                {{ datosProgDocente.nombre_tema }} -
                <span class="font-weight-black">Tema: </span>
                {{ datosProgDocente.nombre_clase }}
              </p>
            </v-col>

          </v-row>

          <v-row>
            <v-col cols="12" class="py-0">
              <v-chip small label>
                Lista de estudiantes de la sección:
                {{ datosProgDocente.nombre_seccion }}
              </v-chip>

              <ComundataTablecomp :headers="ListAsistenciaHeaders" :items="AlumnosSeccion">
                <template v-slot:ap_nombre="{ item }">
                  <span>{{ item.ape1_persona + " " + item.ape2_persona + " " + item.nombre_persona }}</span>
                </template>

                <template v-slot:id_estado_asistencia="{ item }">
                  <v-select v-model="item.id_estado_asistencia" :items="asistenciaEstado" item-value="id"
                    item-text="desc_estado" label="Asistencia del estudiante" :rules="validationRules.validateCampoList"
                    @change="eventAsistenciaEstado($event, item)">
                  </v-select>
                </template>

                <template v-slot:observacion_asistencia="{ item }">
                  <v-text-field v-model="item.observacion_asistencia" label="Observación" class="pb-0 pt-1" type="text"
                    dense single-line :disabled="item.alumno_check == false"></v-text-field>
                </template>

                <template v-slot:cargar_documento="{ item }">
                  <ButtonComp @click="cargarDocumento(item)" uploadButton tooltipText="Cargar documento" />

                </template>

                <template v-slot:descargar_documento="{ item }">
                  <ButtonComp :disabled="item.archivo_asistencia == null" fab x-small @click="
                    download(URL_SPACE + '/' + item.ruta_asistencia)
                  " downloadButton tooltipText="Descargar documento" />
                </template>
              </ComundataTablecomp>

            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp @click="saveItem(true)" textButton="Guardar" iconBut="fas fa-save" normalButton />
          <ButtonComp @click="$emit('close')" textButton="Cancelar" classButton="ml-2" classColor="red" normalButton />
        </template>
      </ComunDialogComp>
    </v-form>

    <!-- end de formulario de actividades  -->
    <!-- formulario de cargar archivo  -->

    <v-form ref="formDatos" lazy-validation>
      <ComunDialogComp v-model="modal_cargarArchivo" maxWidth="500"
        :title="'Estudiante : ' + itemsCargarDocum.nombre_apellido_alumno" @close-modal="modal_cargarArchivo = false">
        <template v-slot:body>
          <v-row>
            <!--  color_estado -->
            <v-col cols="12" class="d-flex justify-center">
              <p class="body-1 mb-0 black--text">
                <span class="font-weight-black">Sección: </span>
                {{ itemsCargarDocum.nombre_seccion }} -
                <span class="font-weight-black">Documento de identidad: </span>
                {{ itemsCargarDocum.numdoc_alumno }} -
                <span class="font-weight-black">Estado: </span>
                {{ itemsCargarDocum.desc_estado }}
              </p>
            </v-col>
            <br />

            <v-col cols="12">
              <v-file-input v-model="archivoSubir" accept=".docx,.pdf,.doc" label="Cargar archivo"
                :rules="validationRules.validateCampo"></v-file-input>
            </v-col>
          </v-row>
        </template>
        <template v-slot:actions>
          <v-spacer></v-spacer>
          <ButtonComp @click="saveFile" textButton="Guardar" iconBut="fas fa-save" normalButton />
          <ButtonComp @click="modal_cargarArchivo = false" textButton="Cancelar" normalButton classButton="ml-2"
            classColor="red" />
        </template>
      </ComunDialogComp>
    </v-form>
    <!-- fin modal cargar archivo -->
  </div>
</template>

<script>
import axios, { API_URL } from "@/helpers/axios";
import { mapMutations, mapGetters, mapActions } from "vuex";
import { BUCKET_ORIGIN_SPACE } from '../../../../helpers/axios';
import ComunDialogComp from '../../../../components/ComponentsEst/ComunDialogComp.vue';
import ButtonComp from '../../../../components/ComponentsEst/TableButtonComp.vue';
import ComundataTablecomp from '../../../../components/ComponentsEst/ComundataTablecomp.vue';
import { ListAsistenciaHeaders } from "../../../../helpers/headersTable";
import { validationRules } from "../../../../helpers/validatorHelpers";
//import ModalCrearActividades from './CrearActividad.vue'

export default {
  name: "modalVerActividadDocente",

  props: ["modalAsistencia", "datosProgDocente"],
  components: {
    ComunDialogComp,
    ButtonComp,
    ComundataTablecomp
  },

  data: () => ({
    paramComponente: { id_submodulo: 26, id_modulo: 7 },
    datoLogin: sessionStorage,

    AlumnosSeccion: [],
    parametrosAsistencia: [],
    asistenciaEstado: [],
    modal_cargarArchivo: false,
    archivoSubir: null,
    itemsCargarDocum: [],
    ListAsistenciaHeaders,

    ruta_api: API_URL, //ruta del servidor
    URL_SPACE: BUCKET_ORIGIN_SPACE,
  }),

  computed: {
    ...mapGetters("login", ["componenteEvento"]),
    validationRules() {
      return validationRules
    }
  },

  mounted() {
    //this.listarTemas();
    this.loadMain();
  },

  watch: {
    // cada vez que la pregunta cambie, esta función será ejecutada
    modalAsistencia: function () {
      if (this.modalAsistencia) {
        this.loadMain();
      } else {
        this.parametrosAsistencia = {};
        this.AlumnosSeccion = [];
      }
    },
  },

  methods: {
    //////////////////////// NO MOVER CONFIGURACION PRINCIPAL DE CADA VISTA////////////////////////
    //  ------- MENSAJE DE SISTEMA  --------
    ...mapMutations("mensajeSis", ["setEnviarMens"]),

    //----- Validar accesos por perfil ------------
    ...mapActions("login", ["parametroComponente"]),

    actualizarParamentro() {
      this.parametroComponente(this.paramComponente);
    },

    async loadMain() {
      this.limpiarFormAct();
      try {

        let params = `/periodo/${this.datoLogin.id_ano_lectivo}/colegio/${this.datoLogin.id_colegio}/programacion/${this.datosProgDocente.id}/seccion/${this.datosProgDocente.id_seccion}/usuario/${this.datoLogin.id}`;
        let response = await axios.get(
          `/academico/asistencia/crearAsistencia${params}`
        );
        let data = response.data;

        this.asistenciaEstado = data.AsistenciaEstado;
        this.AlumnosSeccion = data.SeccionAlumno;

        if (data.mensaggeT == "E") {
          this.setEnviarMens({
            tipo: data.mensaggeT,
            mensaje: data.mensagge,
            tiempo: null,
          });
        }
      } catch (e) {
        this.setEnviarMens({ tipo: "E", mensaje: e, tiempo: null });
      }
    },

    eventAsistenciaEstado(value, item) {

      const selectedItem = this.asistenciaEstado.find(item => item.id == value);
      if (selectedItem) {
        item.desc_estado = selectedItem.desc_estado;
        console.log('item', item);
      }
    },

    async cargarDocumento(item) {
      this.modal_cargarArchivo = true;
      this.itemsCargarDocum = item;
      this.archivoSubir = null;
    },

    async saveItem(flag) {
      try {
        let res = await axios.post("/academico/asistencia/", {
          parametros: this.parametrosAsistencia,
          alumnos: this.AlumnosSeccion,
        });

        this.setEnviarMens({
          tipo: res.data.messageT,
          //mensaje: res.data.message,
          mensaje: flag ? `¡Información creada con éxito!` : `¡Archivo subido con éxito!`,
          tiempo: null,
        });
        if (flag) {
          this.$emit('close')
        }
        this.loadMain();
      } catch (error) {
        this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
      }
    },

    limpiarFormAct() {
      this.parametrosAsistencia = {
        id_prog_docente: this.datosProgDocente.id,
        id_usuario: this.datoLogin.id,
        id_nivel: this.datosProgDocente.id_nivel,
        id_grado: this.datosProgDocente.id_grado,
      };
    },

    async saveFile() {
      if (!this.archivoSubir) {
        this.setEnviarMens({
          tipo: "W",
          mensaje: `Debe subir un archivo`,
          tiempo: null,
        });
      } else {
        try {
          let formData = new FormData();
          formData.append("subirArchivo", this.archivoSubir);
          formData.append("usuario", this.datoLogin.id);
          formData.append("colegio", this.datoLogin.id_colegio);
          formData.append("periodo", this.datoLogin.id_ano_lectivo);
          formData.append(
            "progDocente",
            this.parametrosAsistencia.id_prog_docente
          );
          formData.append("nivel", this.parametrosAsistencia.id_nivel);
          formData.append("grado", this.parametrosAsistencia.id_grado);
          formData.append("seccion", this.itemsCargarDocum.id_seccion);
          formData.append("alumno", this.itemsCargarDocum.id_alumno);
          formData.append(
            "estadoAsistencia",
            this.itemsCargarDocum.id_estado_asistencia
          );

          let res = await axios.post(
            "/academico/progDocenteFiles/addAsistencia/",
            formData,
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          if (res.data.messageT == "S") {
            this.modal_cargarArchivo = false;
            this.saveItem(false)
          }
        } catch (error) {
          this.setEnviarMens({ tipo: "E", mensaje: `${error}`, tiempo: null });
        }
      }
    },

    async download(url) {
      await this.$Files['downloadFetch']({ url });
    },
  },
};
</script>

